import { MatterLitigationDateTypesTable } from "@/components/features/settings/defaults/matter-litigation-date-types/MatterLitigationDateTypesTable";

export default function MatterLitigationDateTypes({
  isAdding,
  setIsAdding,
}: {
  isAdding: boolean;
  setIsAdding: (open: boolean) => void;
}) {
  return (
    <MatterLitigationDateTypesTable
      isAdding={isAdding}
      setIsAdding={setIsAdding}
    />
  );
}
